import {
  OrgnizationUserActionTypes,
  REVOKE_ORGANIZATION_USER_ROLES_API_SUCCESS,
} from '../../organization-user/organization-user.actions';

type OrganizationUserEntityActionTypes = OrgnizationUserActionTypes;

export const organizationUserEntityReducer = (state: any = {}, action: OrganizationUserEntityActionTypes) => {
  if (action.type === REVOKE_ORGANIZATION_USER_ROLES_API_SUCCESS) {
    const orgUserId = action.payload;
    const foundOrgUser = state[orgUserId];

    return {
      ...state,
      [orgUserId]: {
        ...foundOrgUser,
        roles: [],
      },
    };
  }
  return state;
};
